export enum UserStatus {
  New = 'NEW',
  Verified = 'VERIFIED',
  CompletedReg = 'COMPLETED_REGISTRATION',
  Blocked = 'BLOCKED',
}
